
import { Component, Vue } from "vue-property-decorator";
import GalleryPanelComponent from "./components/gallery/gallery-panel.vue";
import CaptionPanelComponent from "./components/caption/caption-panel.vue";
import InstructionsPanelComponent from "./components/instructions/instructions-panel.vue";

@Component({
    components: {
        "gallery-panel": GalleryPanelComponent,
        "caption-panel": CaptionPanelComponent,
        "instructions-panel": InstructionsPanelComponent
    },
    data() {
        return {};
    }
})
export default class App extends Vue {}
